import typeforce from '@exodus/typeforce'
// eslint-disable-next-line no-restricted-imports -- TODO: Fix this the next time the file is edited.
import lodash from 'lodash'

const { sortedIndexBy } = lodash

const OS_LIST = new Set(['ios', 'android', 'darwin', 'linux', 'win32'])
const BUILD_LIST = new Set(['genesis', 'mobile', 'eden', 'exodus', 'nile', 'browser'])
const SYNC_CANCELED_REASON_LIST = new Set([
  'oldDesktop',
  'noSeed',
  'twoSeedsWithHistory',
  'desktopHasBalance',
  'mobileHasBalance',
])

const APPLICATION_IMPORT_OPTS_BACKUP_TYPES = new Set(['passkeys', 'seed-phrase', 'v3'])

const eventType = typeforce.compile({
  event: 'String',
  build: (value) => BUILD_LIST.has(value),
  timestamp: (value) => !isNaN(new Date(value).getTime()),
  version: (value) => /^\d+(\.\d+)+$/u.test(value),
  asset: '?string',
  type: '?String',
  // seed-backup-plugin
  age: '?Number',
  maxAge: '?Number',
  // sync devices
  osName: typeforce.maybe((value) => OS_LIST.has(value)),
  syncCanceledReason: typeforce.maybe((value) => SYNC_CANCELED_REASON_LIST.has(value)),
  // seedless
  isUploadFailed: '?Boolean',
  backupId: '?String',
  // application
  applicationImportOpts: typeforce.maybe({
    forceRestart: '?Boolean',
    forgotPassphrase: '?Boolean',
    backupType: typeforce.maybe((value) => APPLICATION_IMPORT_OPTS_BACKUP_TYPES.has(value)),
  }),
  applicationWillFireClearHookOpts: typeforce.maybe({
    isImporting: 'Boolean',
    isDeleting: 'Boolean',
    walletExists: 'Boolean',
  }),
})

const createEventLog = ({
  eventLogAtom,
  getBuildMetadata,
  config: { versionHistoryEventName },
}) => {
  const record = async (data) => {
    data = typeof data === 'string' ? { event: data } : data

    if (!(data.event && typeof data.event === 'string')) {
      throw new Error('expected non-empty string "event"')
    }

    const { build, version } = await getBuildMetadata()

    const event = { ...data, build, timestamp: Date.now(), version }
    typeforce(eventType, event, true)

    await eventLogAtom.set((events) => {
      const idx = sortedIndexBy(events, event, 'timestamp')
      return [
        //
        ...events.slice(0, idx),
        event,
        ...events.slice(idx),
      ]
    })
  }

  const exportFormatted = async () => {
    const events = await eventLogAtom.get()
    return events.map((event) => ({
      ...event,
      timestamp: new Date(event.timestamp).toUTCString(), // utc date string, e.g. "Wed, 14 Jun 2017 07:00:00 GMT"
    }))
  }

  const isEmpty = async () => {
    const events = await eventLogAtom.get()
    return events.length === 0
  }

  const remove = ({ timestamp }) =>
    eventLogAtom.set((events) => {
      const index = events.findIndex((e) => e.timestamp === timestamp)
      return index === -1 ? events : events.filter((_, i) => i !== index)
    })

  const getVersionHistory = async () => {
    const events = await eventLogAtom.get()
    return events.filter(({ event }) => event === versionHistoryEventName)
  }

  return {
    record,
    exportFormatted,
    isEmpty,
    remove,
    getVersionHistory,
  }
}

const eventLogModuleDefinition = {
  id: 'eventLog',
  type: 'module',
  factory: createEventLog,
  dependencies: ['eventLogAtom', 'getBuildMetadata', 'config'],
  public: true,
}

export default eventLogModuleDefinition
